import React from "react";
import { Form, Input, message, Button, Card } from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";
import ChildManagerService from "Services/AdminServices/ChildManagerService";
import { useForm } from "antd/es/form/Form";

const SetPassword = () => {
  const [form] = useForm();
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const userId = params.get("userId");
  const token = params.get("token");

  const handleSubmit = async (values) => {
    if (values.password !== values.confirmPassword) {
      message.error("Passwords do not match");
      return;
    }

    try {
      await ChildManagerService.acceptInvite({
        userId: Number(userId),
        token,
        password: values.password,
      });
      localStorage.removeItem("token");
      localStorage.removeItem("userId");
      sessionStorage.clear();
      message.success("Password set successfully. Please Login");
      navigate("/signIn");
    } catch (error) {
      console.error("Error accepting Invite", error);

      const backendMessage =
        typeof error === "string"
          ? error
          : error.message || error.error || "Failed to set password";

      if (backendMessage.includes("already been used")) {
        message.error(
          "This invite link has already been used or expired. Please request a new one."
        );
      } else {
        message.error(backendMessage);
      }
    }
  };

  return (
    <Card title="Set Your Password" style={{ maxWidth: 400, margin: "50px auto" }}>
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          name="password"
          label="Password"
          rules={[{ required: true, message: " Please enter your password" }]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          name="confirmPassword"
          label="Confirm Password"
          rules={[{ required: true, message: " Please Confirm your password" }]}
        >
          <Input.Password />
        </Form.Item>

        <Button className="btn-primary" htmlType="submit">
          Set Password
        </Button>
      </Form>
    </Card>
  );
};
export default SetPassword;
